var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeLinejoin: "round",
    style: {
      color: "currentcolor"
    },
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#loader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16v-4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.298 1.528 2.35 3.236",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.702 1.528-2.35 3.236",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.702 14.472-2.35-3.236",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.298 14.472 2.35-3.236",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.609 5.528-3.805 1.236",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.392 10.472 3.804-1.236",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.609 10.472-3.805-1.236",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.392 5.528 3.804 1.236",
    opacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loader_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgLoader;